import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`type`}</strong><br />{`string, optional, 'range' by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The kind of control we're describing. Can be one of: `}<inlineCode parentName="td">{`checkbox`}</inlineCode>{`, `}<inlineCode parentName="td">{`input`}</inlineCode>{`, `}<inlineCode parentName="td">{`radio`}</inlineCode>{`, `}<inlineCode parentName="td">{`range`}</inlineCode>{`, `}<inlineCode parentName="td">{`select`}</inlineCode>{`, `}<inlineCode parentName="td">{`timer`}</inlineCode>{` or `}<inlineCode parentName="td">{`toggle`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`label`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The label which will describe the control.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`name`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the control. If not specified, `}<inlineCode parentName="td">{`label`}</inlineCode>{` will be used.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`param`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<inlineCode parentName="td">{`param`}</inlineCode>{` that this control will update.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`resetOnChange`}</strong><br />{`boolean, optional, false by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the model will be reset if the control changes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`setParams`}</strong><br />{`function, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`setValue`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This function will be called whenever the control changes to update its value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`value`}</strong><br />{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The current value of the control.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "setparams"
    }}>{`setParams`}</h3>
    <p>{`By default, a control, when changed, will take its `}<inlineCode parentName="p">{`value`}</inlineCode>{` and use it to update the `}<inlineCode parentName="p">{`param`}</inlineCode>{` of the control, as is.
Instead, a `}<inlineCode parentName="p">{`setParams`}</inlineCode>{` function can be created that takes, as input, the `}<inlineCode parentName="p">{`value`}</inlineCode>{` of the control, and which will output an object with one or more params as keys.
With a setParams function, a control can update several params at once, or have a transformation between the value of the control and what is passed to the params.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      